import React from "react";
import { useState, useEffect } from "react";
import { MdAdd } from "react-icons/md";
import { Link } from "react-router-dom";
import { getBillExportApi, getBillsApi } from "../../services/BillingService";
import { Spinner } from "react-bootstrap";
import Pagination from "../Constant/Pagination";
import DebounceSmallSearchInput from "../Constant/DebounceSmallSearchInput";
import { CancelRequest } from "../../services/AxiosInstance";
import { FaDownload, FaInfo } from "react-icons/fa";
import { CustomTooltip } from "../../components/CustomTooltip";
import DatePicker from "react-datepicker";
import { BiSolidFileExport } from "react-icons/bi";
import { IoClose } from "react-icons/io5";
import { FaEdit } from "react-icons/fa";
import { BiSolidDiscount } from "react-icons/bi";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import { FaInfoCircle } from "react-icons/fa";
import {
  FaRupeeSign,
  FaMoneyBillWave,
  FaFileInvoiceDollar,
  FaCheckCircle,
  FaTimesCircle,
  FaAdjust,
} from "react-icons/fa";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import {
  dateRangeOptions,
  formatToIndianNumber,
  paymentMethodBadge,
  paymentMoethodOption,
  paymentStatusBadge,
  paymentStatusOption,
} from "../../utilities";
import { format } from "date-fns";
import GlobalSearchableDropdown from "../Constant/SearchableDropdown";
import { subDays, startOfMonth, endOfMonth, subMonths } from "date-fns";
import { useSelector } from "react-redux";
import BillingEditPaymnetModal from "./BillingEditPaymentModal";
import { toast } from "react-toastify";
import SearchWithFilter from "../Constant/SearchWithFilter";
import { FiEdit2 } from "react-icons/fi";
import { getServiceCenterOptionApi } from "../../services/SearchService";
const Billing = () => {
  const userRole = useSelector((state) =>
    state.auth.user?.is_superuser ? "admin" : "user" || "user"
  );
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [selectedPaymentStatus, setSelecetdPaymentStatus] = useState(null);
  const [selectedDate, setSelectedDate] = useState(dateRangeOptions[0]);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectBill, setSelectBill] = useState(null);
  const [billDetailsModal, setBillDetailsModal] = useState(null);
  const [editPaymentModal, setEditPaymentModal] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [servicecenterOption, setServiceCenterOption] = useState([]);
  const [selectedServiceCenter, setSelectedServiceCenter] = useState(null);
  // const [now, setNow] = useState(Date.now());

  // useEffect(() => {
  //   const interval = setInterval(() => setNow(Date.now()), 1000);
  //   return () => clearInterval(interval);
  // }, []);
  const [billingSummary, setBillingSummary] = useState({
    total_amount: 0,
    payment_received: 0,
    total_outstanding: 0,
    paid_count: 0,
    unpaid_count: 0,
    partially_paid_count: 0,
    partially_paid_amount: 0,
    total_discount: 0,
    total_tips: 0,
  });
  const [param, setParam] = useState({
    page: "1",
    page_size: "10",
    query: "",
    start_date: format(new Date(), "yyyy-MM-dd"),
    end_date: format(new Date(), "yyyy-MM-dd"),
    payment_status: "",
    payment_method: "",
    service_center: "",
  });

  const handleTogglePaymentModal = () => {
    if (editPaymentModal) {
      setSelectBill(null);
    }
    setEditPaymentModal(!editPaymentModal);
  };
  const handleAfterEditPayment = () => {
    handleTogglePaymentModal();
    getData();
  };
  const getData = () => {
    setLoading(true);
    getBillsApi(param)
      .then((res) => {
        setError("");
        setData(res?.data?.results.billings || []);
        setTotal(res?.data?.results?.count || 0);
        setBillingSummary(res?.data?.results?.summary);
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getServiceCenter = () => {
    getServiceCenterOptionApi()
      .then((res) => {
        setServiceCenterOption(res?.data?.results || []);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };

  useEffect(() => {
    if (userRole == "admin") {
      getServiceCenter();
    }
  }, []);
  useEffect(() => {
    getData();
  }, [param]);

  const handleToggleBillModal = () => {
    if (billDetailsModal) {
      setSelectBill(null);
    }
    setBillDetailsModal(!billDetailsModal);
  };
  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };
  const handleDateRangeChange = (option) => {
    setSelectedDate(option);
    if (!option) {
      setParam({
        ...param,
        start_date: "",
        end_date: "",
        page: "1",
      });
      return;
    }
    let startDate,
      endDate = new Date();
    switch (option.value) {
      case "today":
        startDate = new Date();
        endDate = new Date();
        break;
      case "yesterday":
        startDate = subDays(new Date(), 1);
        endDate = startDate;
        break;
      case "7_days":
        startDate = subDays(new Date(), 7);
        break;
      case "15_days":
        startDate = subDays(new Date(), 15);
        break;
      case "30_days":
        startDate = subDays(new Date(), 30);
        break;
      case "last_month":
        startDate = startOfMonth(subMonths(new Date(), 1));
        endDate = endOfMonth(subMonths(new Date(), 1));
        break;
      case "3_months":
        startDate = startOfMonth(subMonths(new Date(), 3));
        endDate = endOfMonth(subMonths(new Date(), 1));
        break;
      case "custom":
        setShowDatePicker(true);
        return;
      default:
        return;
    }
    setShowDatePicker(false);
    setParam({
      ...param,
      start_date: format(startDate, "yyyy-MM-dd"),
      end_date: format(endDate, "yyyy-MM-dd"),
      page: "1",
    });
  };

  useEffect(() => {
    const paymentMethod = selectedPaymentMethod?.value || "";
    const paymentStatus = selectedPaymentStatus?.value || "";
    const sCenter = selectedServiceCenter?.value || "";

    if (
      param?.payment_method !== paymentMethod ||
      param?.payment_status !== paymentStatus ||
      param?.service_center !== sCenter
    ) {
      setParam({
        ...param,
        payment_method: paymentMethod,
        payment_status: paymentStatus,
        service_center: sCenter,
      });
    }
  }, [selectedPaymentMethod, selectedPaymentStatus, selectedServiceCenter]);

  const handleExport = () => {
    setExportLoading(true);
    getBillExportApi({ ...param, export: true })
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "Bill-report.xlsx";

        // Append to DOM to make it more consistent
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setExportLoading(false);
      });
  };
  const getValueByKey = (obj, key) => {
    return key
      .split(".")
      .reduce((acc, part) => (acc ? acc[part] : undefined), obj);
  };
  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return <FaSort className="sort-icon neutral" />;
    }
    return sortConfig.direction === "asc" ? (
      <FaSortUp className="sort-icon active" />
    ) : (
      <FaSortDown className="sort-icon active" />
    );
  };
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sorted = [...data].sort((a, b) => {
      const valA = getValueByKey(a, key);
      const valB = getValueByKey(b, key);

      const numA = parseFloat(valA);
      const numB = parseFloat(valB);
      const dateA = Date.parse(valA);
      const dateB = Date.parse(valB);

      // Numeric sort if both are valid numbers
      if (!isNaN(numA) && !isNaN(numB)) {
        return direction === "asc" ? numA - numB : numB - numA;
      }

      // Date sort if both are valid dates
      if (!isNaN(dateA) && !isNaN(dateB)) {
        return direction === "asc" ? dateA - dateB : dateB - dateA;
      }

      // Fallback to string sort (letters, "inf", etc.)
      return direction === "asc"
        ? String(valA).localeCompare(String(valB), undefined, {
            sensitivity: "base",
          })
        : String(valB).localeCompare(String(valA), undefined, {
            sensitivity: "base",
          });
    });

    setData(sorted);
  };

  return (
    <div>
      <div className="card mb-3">
        <div className="d-flex justify-content-between align-items-start gap-2 flex-start p-3 flex-wrap">
          <div className="d-flex flex-column">
            <h5 className="mb-0">Billing Dashboard</h5>
            <span
              className="text-dark fw-medium"
              style={{ fontSize: "0.8rem" }}
            >
              Manage your invoice and payments
            </span>
          </div>
          <div className="d-flex gap-2">
            {userRole == "user" && (
              <div>
                <Link
                  to="/bill-add"
                  className="btn btn-primary px-2"
                  // style={{ padding: "0.45rem 0" }}
                >
                  <MdAdd className="me-1" size="20" />
                  Add Bill
                </Link>
              </div>
            )}
            {userRole !== "user" && (
              <button
                className="btn btn-success"
                onClick={handleExport}
                disabled={exportLoading || data?.length == 0}
              >
                {exportLoading ? (
                  <Spinner size="sm me-1" animation="border" />
                ) : (
                  <FaDownload className="me-1" />
                )}
                Export
              </button>
            )}
          </div>
        </div>
        <div className="row g-3 py-2 px-3">
          <div className="col-6 col-md-4 col-lg-2">
            <div
              className="card shadow-sm rounded-4 h-100 overflow-hidden"
              style={{
                background: "linear-gradient(145deg, #ffffff, #f1f5f9)",
                position: "relative",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow =
                  "0 10px 20px rgba(0, 0, 0, 0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(0, 0, 0, 0.1)";
              }}
            >
              {/* Decorative Gradient Orbs */}
              <div
                style={{
                  position: "absolute",
                  top: "-15%",
                  left: "-15%",
                  width: "140px",
                  height: "140px",
                  background:
                    "linear-gradient(135deg, rgba(59, 130, 246, 0.15), rgba(147, 197, 253, 0.1))",
                  borderRadius: "50%",
                  filter: "blur(50px)",
                  opacity: "0.7",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: "-20%",
                  right: "-20%",
                  width: "120px",
                  height: "120px",
                  background:
                    "linear-gradient(135deg, rgba(59, 130, 246, 0.12), rgba(147, 197, 253, 0.08))",
                  borderRadius: "50%",
                  filter: "blur(40px)",
                  opacity: "0.5",
                  pointerEvents: "none",
                }}
              ></div>
              {/* Border Accent */}
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "4px",
                  background: "linear-gradient(90deg, #3b82f6, #60a5fa)",
                  borderRadius: "4px 4px 0 0",
                }}
              ></div>
              <div className="card-body d-flex flex-column align-items-center p-3">
                <div className="d-flex align-items-center">
                  <span
                    className="rounded-circle me-1 d-flex justify-content-center align-items-center"
                    style={{
                      width: "20px",
                      height: "20px",
                      background: "linear-gradient(135deg, #3b82f6, #60a5fa)",
                      boxShadow: "0 4px 10px rgba(59, 130, 246, 0.3)",
                      transition: "transform 0.3s ease",
                    }}
                  >
                    <FaRupeeSign size={10} color="white" />
                  </span>
                  <span
                    className="fw-medium"
                    style={{ fontSize: "0.85rem", color: "#1e3a8a" }}
                  >
                    Total Amount
                  </span>
                </div>
                <span
                  className="fw-bold"
                  style={{ fontSize: "1.2rem", color: "#1e3a8a" }}
                >
                  ₹{formatToIndianNumber(billingSummary?.total_amount || 0)}
                </span>
                <span
                  className="fw-medium"
                  style={{
                    fontSize: "0.6rem",
                    color: "#6b7280",
                  }}
                >
                  (Total Revenue)
                </span>
              </div>
            </div>
          </div>

          <div className="col-6 col-md-4 col-lg-2">
            <div
              className="card shadow-sm rounded-4 h-100 overflow-hidden"
              style={{
                background: "linear-gradient(145deg, #ffffff, #f1f5f9)",
                position: "relative",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow =
                  "0 10px 20px rgba(0, 0, 0, 0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(0, 0, 0, 0.1)";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-15%",
                  left: "-15%",
                  width: "140px",
                  height: "140px",
                  background:
                    "linear-gradient(135deg, rgba(236, 72, 153, 0.15), rgba(251, 207, 232, 0.1))",
                  borderRadius: "50%",
                  filter: "blur(50px)",
                  opacity: "0.7",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: "-20%",
                  right: "-20%",
                  width: "120px",
                  height: "120px",
                  background:
                    "linear-gradient(135deg, rgba(236, 72, 153, 0.12), rgba(251, 207, 232, 0.08))",
                  borderRadius: "50%",
                  filter: "blur(40px)",
                  opacity: "0.5",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "4px",
                  background: "linear-gradient(90deg, #ec4899, #f9a8d4)",
                  borderRadius: "4px 4px 0 0",
                }}
              ></div>
              <div className="card-body d-flex flex-column align-items-center p-3">
                <div className="d-flex align-items-center">
                  <span
                    className="rounded-circle me-1 d-flex justify-content-center align-items-center"
                    style={{
                      width: "20px",
                      height: "20px",
                      background: "linear-gradient(135deg, #ec4899, #f9a8d4)",
                      boxShadow: "0 4px 10px rgba(236, 72, 153, 0.3)",
                      transition: "transform 0.3s ease",
                    }}
                  >
                    <FaRupeeSign size={10} color="white" />
                  </span>
                  <span
                    className="fw-medium"
                    style={{ fontSize: "0.85rem", color: "#1e3a8a" }}
                  >
                    Total Tips
                  </span>
                </div>
                <span
                  className="fw-bold"
                  style={{ fontSize: "1.2rem", color: "#1e3a8a" }}
                >
                  ₹{formatToIndianNumber(billingSummary?.total_tips || 0)}
                </span>
                <span
                  className="fw-medium"
                  style={{ fontSize: "0.6rem", color: "#6b7280" }}
                >
                  (Total Tips)
                </span>
              </div>
            </div>
          </div>

          <div className="col-6 col-md-4 col-lg-2">
            <div
              className="card shadow-sm rounded-4 h-100 overflow-hidden"
              style={{
                background: "linear-gradient(145deg, #ffffff, #f1f5f9)",
                position: "relative",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow =
                  "0 10px 20px rgba(0, 0, 0, 0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(0, 0, 0, 0.1)";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-15%",
                  left: "-15%",
                  width: "140px",
                  height: "140px",
                  background:
                    "linear-gradient(135deg, rgba(59, 130, 246, 0.15), rgba(147, 197, 253, 0.1))",
                  borderRadius: "50%",
                  filter: "blur(50px)",
                  opacity: "0.7",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: "-20%",
                  right: "-20%",
                  width: "120px",
                  height: "120px",
                  background:
                    "linear-gradient(135deg, rgba(59, 130, 246, 0.12), rgba(147, 197, 253, 0.08))",
                  borderRadius: "50%",
                  filter: "blur(40px)",
                  opacity: "0.5",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "4px",
                  background: "linear-gradient(90deg, #3b82f6, #60a5fa)",
                  borderRadius: "4px 4px 0 0",
                }}
              ></div>
              <div className="card-body d-flex flex-column align-items-center p-3">
                <div className="d-flex align-items-center">
                  <span
                    className="rounded-circle me-1 d-flex justify-content-center align-items-center"
                    style={{
                      width: "20px",
                      height: "20px",
                      background: "linear-gradient(135deg, #3b82f6, #60a5fa)",
                      boxShadow: "0 4px 10px rgba(59, 130, 246, 0.3)",
                      transition: "transform 0.3s ease",
                    }}
                  >
                    <BiSolidDiscount size={10} color="white" />
                  </span>
                  <span
                    className="fw-medium"
                    style={{ fontSize: "0.85rem", color: "#1e3a8a" }}
                  >
                    Discounts
                  </span>
                </div>
                <span
                  className="fw-bold"
                  style={{ fontSize: "1.2rem", color: "#1e3a8a" }}
                >
                  ₹{formatToIndianNumber(billingSummary?.total_discount || 0)}
                </span>
                <span
                  className="fw-medium"
                  style={{ fontSize: "0.6rem", color: "#6b7280" }}
                >
                  (Total Discounts)
                </span>
              </div>
            </div>
          </div>

          <div className="col-6 col-md-4 col-lg-2">
            <div
              className="card shadow-sm rounded-4 h-100 overflow-hidden"
              style={{
                background: "linear-gradient(145deg, #ffffff, #f1f5f9)",
                position: "relative",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow =
                  "0 10px 20px rgba(0, 0, 0, 0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(0, 0, 0, 0.1)";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-15%",
                  left: "-15%",
                  width: "140px",
                  height: "140px",
                  background:
                    "linear-gradient(135deg, rgba(34, 197, 94, 0.15), rgba(187, 247, 208, 0.1))",
                  borderRadius: "50%",
                  filter: "blur(50px)",
                  opacity: "0.7",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: "-20%",
                  right: "-20%",
                  width: "120px",
                  height: "120px",
                  background:
                    "linear-gradient(135deg, rgba(34, 197, 94, 0.12), rgba(187, 247, 208, 0.08))",
                  borderRadius: "50%",
                  filter: "blur(40px)",
                  opacity: "0.5",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "4px",
                  background: "linear-gradient(90deg, #22c55e, #86efac)",
                  borderRadius: "4px 4px 0 0",
                }}
              ></div>
              <div className="card-body d-flex flex-column align-items-center p-3">
                <div className="d-flex align-items-center">
                  <span
                    className="rounded-circle me-1 d-flex justify-content-center align-items-center"
                    style={{
                      width: "20px",
                      height: "20px",
                      background: "linear-gradient(135deg, #22c55e, #86efac)",
                      boxShadow: "0 4px 10px rgba(34, 197, 94, 0.3)",
                      transition: "transform 0.3s ease",
                    }}
                  >
                    <FaMoneyBillWave size={10} color="white" />
                  </span>
                  <span
                    className="fw-medium"
                    style={{ fontSize: "0.85rem", color: "#1e3a8a" }}
                  >
                    Received ({billingSummary?.paid_count || 0})
                    <CustomTooltip
                      title={
                        <div>
                          <div>
                            <strong>Cash:</strong> ₹
                            {formatToIndianNumber(
                              billingSummary?.payment_source_breakdown?.["CASH"]
                            )}
                          </div>
                          <div>
                            <strong>Card:</strong> ₹
                            {formatToIndianNumber(
                              billingSummary?.payment_source_breakdown?.["CARD"]
                            )}
                          </div>
                          <div>
                            <strong>UPI Business:</strong> ₹
                            {formatToIndianNumber(
                              billingSummary?.payment_source_breakdown?.[
                                "UPI BUSINESS"
                              ]
                            )}
                          </div>
                          <div>
                            <strong>UPI Personal:</strong> ₹
                            {formatToIndianNumber(
                              billingSummary?.payment_source_breakdown?.[
                                "UPI PERSONAL"
                              ]
                            )}
                          </div>
                        </div>
                      }
                      placement="right"
                    >
                      <span
                        className="ms-1"
                        style={{
                          cursor: "pointer",
                        }}
                      >
                        <FaInfoCircle size={15} className="text-secondary" />
                      </span>
                    </CustomTooltip>
                  </span>
                </div>
                <span
                  className="fw-bold"
                  style={{ fontSize: "1.2rem", color: "#1e3a8a" }}
                >
                  ₹{formatToIndianNumber(billingSummary?.payment_received || 0)}
                </span>
                <span
                  className="fw-medium"
                  style={{ fontSize: "0.6rem", color: "#6b7280" }}
                >
                  (
                  {billingSummary?.total_amount > 0
                    ? `${(
                        (billingSummary.payment_received /
                          billingSummary.total_amount) *
                        100
                      ).toFixed(2)}% of total`
                    : "0% of total"}
                  )
                </span>
              </div>
            </div>
          </div>

          <div className="col-6 col-md-4 col-lg-2">
            <div
              className="card shadow-sm rounded-4 h-100 overflow-hidden"
              style={{
                background: "linear-gradient(145deg, #ffffff, #f1f5f9)",
                position: "relative",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow =
                  "0 10px 20px rgba(0, 0, 0, 0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(0, 0, 0, 0.1)";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-15%",
                  left: "-15%",
                  width: "140px",
                  height: "140px",
                  background:
                    "linear-gradient(135deg, rgba(239, 68, 68, 0.15), rgba(254, 202, 202, 0.1))",
                  borderRadius: "50%",
                  filter: "blur(50px)",
                  opacity: "0.7",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: "-20%",
                  right: "-20%",
                  width: "120px",
                  height: "120px",
                  background:
                    "linear-gradient(135deg, rgba(239, 68, 68, 0.12), rgba(254, 202, 202, 0.08))",
                  borderRadius: "50%",
                  filter: "blur(40px)",
                  opacity: "0.5",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "4px",
                  background: "linear-gradient(90deg, #ef4444, #f87171)",
                  borderRadius: "4px 4px 0 0",
                }}
              ></div>
              <div className="card-body d-flex flex-column align-items-center p-3">
                <div className="d-flex align-items-center">
                  <span
                    className="rounded-circle me-1 d-flex justify-content-center align-items-center"
                    style={{
                      width: "20px",
                      height: "20px",
                      background: "linear-gradient(135deg, #ef4444, #f87171)",
                      boxShadow: "0 4px 10px rgba(239, 68, 68, 0.3)",
                      transition: "transform 0.3s ease",
                    }}
                  >
                    <FaFileInvoiceDollar size={10} color="white" />
                  </span>
                  <span
                    className="fw-medium"
                    style={{ fontSize: "0.85rem", color: "#1e3a8a" }}
                  >
                    Outstanding ({billingSummary?.unpaid_count || 0})
                  </span>
                </div>
                <span
                  className="fw-bold"
                  style={{ fontSize: "1.2rem", color: "#1e3a8a" }}
                >
                  ₹
                  {formatToIndianNumber(billingSummary?.total_outstanding || 0)}
                </span>
                <span
                  className="fw-medium"
                  style={{ fontSize: "0.6rem", color: "#6b7280" }}
                >
                  (
                  {billingSummary?.total_amount > 0
                    ? `${(
                        (billingSummary.total_outstanding /
                          billingSummary.total_amount) *
                        100
                      ).toFixed(2)}% Pending`
                    : "0% Pending"}
                  )
                </span>
              </div>
            </div>
          </div>

          <div className="col-6 col-md-4 col-lg-2">
            <div
              className="card border-0 shadow-sm rounded-4 h-100 overflow-hidden"
              style={{
                background: "linear-gradient(145deg, #ffffff, #f1f5f9)",
                position: "relative",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow =
                  "0 10px 20px rgba(0, 0, 0, 0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(0, 0, 0, 0.1)";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-15%",
                  left: "-15%",
                  width: "140px",
                  height: "140px",
                  background:
                    "linear-gradient(135deg, rgba(234, 179, 8, 0.15), rgba(254, 243, 199, 0.1))",
                  borderRadius: "50%",
                  filter: "blur(50px)",
                  opacity: "0.7",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: "-20%",
                  right: "-20%",
                  width: "120px",
                  height: "120px",
                  background:
                    "linear-gradient(135deg, rgba(234, 179, 8, 0.12), rgba(254, 243, 199, 0.08))",
                  borderRadius: "50%",
                  filter: "blur(40px)",
                  opacity: "0.5",
                  pointerEvents: "none",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "4px",
                  background: "linear-gradient(90deg, #eab308, #fde047)",
                  borderRadius: "4px 4px 0 0",
                }}
              ></div>
              <div className="card-body d-flex flex-column align-items-center p-3">
                <div className="d-flex align-items-center">
                  <span
                    className="rounded-circle me-1 d-flex justify-content-center align-items-center"
                    style={{
                      width: "20px",
                      height: "20px",
                      background: "linear-gradient(135deg, #eab308, #fde047)",
                      boxShadow: "0 4px 10px rgba(234, 179, 8, 0.3)",
                      transition: "transform 0.3s ease",
                    }}
                  >
                    <FaAdjust size={10} color="white" />
                  </span>
                  <span
                    className="fw-medium"
                    style={{ fontSize: "0.85rem", color: "#1e3a8a" }}
                  >
                    Adjusted ({billingSummary?.partially_paid_count || 0})
                  </span>
                </div>
                <span
                  className="fw-bold"
                  style={{ fontSize: "1.2rem", color: "#1e3a8a" }}
                >
                  ₹
                  {formatToIndianNumber(
                    billingSummary?.partially_paid_amount || 0
                  )}
                </span>
                <span
                  className="fw-medium"
                  style={{ fontSize: "0.6rem", color: "#6b7280" }}
                >
                  (Partially payments)
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="p-4 d-flex justify-content-between flex-wrap gap-2">
          <div className="d-flex gap-1 flex-fill flex-md-grow-0">
            <div className="flex-fill">
              <DebounceSmallSearchInput
                handleSearchChange={handleSearchChange}
              />
              {/* <SearchWithFilter/> */}
            </div>
          </div>
          <div className="d-flex gap-2 flex-wrap">
            {userRole == "admin" && (
              <div>
                <GlobalSearchableDropdown
                  options={servicecenterOption}
                  selected={selectedServiceCenter}
                  onSelect={(item) => setSelectedServiceCenter(item)}
                  placeholder="Service center"
                />
              </div>
            )}
            <div>
              <GlobalSearchableDropdown
                options={paymentStatusOption}
                selected={selectedPaymentStatus}
                onSelect={(item) => setSelecetdPaymentStatus(item)}
                placeholder="Payment Status"
              />
            </div>
            <div>
              <GlobalSearchableDropdown
                options={paymentMoethodOption}
                selected={selectedPaymentMethod}
                onSelect={(item) => setSelectedPaymentMethod(item)}
                placeholder="Payment Method"
              />
            </div>

            {showDatePicker && (
              <div className="">
                <DatePicker
                  selectsRange
                  startDate={
                    param?.start_date ? new Date(param.start_date) : null
                  }
                  endDate={param?.end_date ? new Date(param.end_date) : null}
                  onChange={(update) => {
                    const [start, end] = update;
                    setParam((prev) => ({
                      ...prev,
                      start_date: start ? format(start, "yyyy-MM-dd") : "",
                      end_date: end ? format(end, "yyyy-MM-dd") : "",
                      page: 1,
                    }));
                  }}
                  isClearable
                  placeholderText="Select date range"
                  className="form-control"
                  style={{
                    fontSize: "0.5rem",
                  }}
                />
              </div>
            )}
            <div className="">
              <GlobalSearchableDropdown
                options={
                  userRole == "user"
                    ? dateRangeOptions.slice(0, 3)
                    : dateRangeOptions
                }
                selected={selectedDate}
                onSelect={(item) => handleDateRangeChange(item)}
                placeholder="Period"
              />
            </div>
          </div>
        </div>

        {loading ? (
          <div className="text-center my-4">
            <Spinner animation="border" />
          </div>
        ) : error ? (
          <div className="text-center my-4 text-danger">{error}</div>
        ) : data && data?.length > 0 ? (
          <div className="table-responsive">
            <table className="table fs-6 mb-0 align-middle">
              <thead className="table-light custom-thead">
                <tr>
                  <th
                    onClick={() => handleSort("invoice_id")}
                    style={{ cursor: "pointer" }}
                  >
                    Invoice{renderSortIcon("invoice_id")}
                  </th>
                  <th
                    onClick={() => handleSort("vehicle.vehicle_number")}
                    style={{ cursor: "pointer" }}
                  >
                    Vehicle{renderSortIcon("vehicle.vehicle_number")}
                  </th>
                  <th
                    onClick={() => handleSort("vehicle.customer_name")}
                    style={{ cursor: "pointer" }}
                  >
                    Customer{renderSortIcon("vehicle.customer_name")}
                  </th>
                  <th
                    onClick={() => handleSort("subtotal")}
                    style={{ cursor: "pointer" }}
                  >
                    Total{renderSortIcon("subtotal")}
                  </th>
                  <th
                    onClick={() => handleSort("discount")}
                    style={{ cursor: "pointer" }}
                  >
                    Discount{renderSortIcon("discount")}
                  </th>
                  <th
                    onClick={() => handleSort("tips")}
                    style={{ cursor: "pointer" }}
                  >
                    Tips{renderSortIcon("tips")}
                  </th>
                  <th
                    onClick={() => handleSort("partial_amount")}
                    style={{ cursor: "pointer" }}
                  >
                    Paid{renderSortIcon("partial_amount")}
                  </th>
                  <th
                    onClick={() => handleSort("payment_status")}
                    style={{ cursor: "pointer" }}
                  >
                    Status{renderSortIcon("payment_status")}
                  </th>
                  <th
                    onClick={() => handleSort("payment_status")}
                    style={{ cursor: "pointer" }}
                  >
                    Mode{renderSortIcon("payment_status")}
                  </th>
                  {/* <th
                    onClick={() => handleSort("date")}
                    style={{ cursor: "pointer" }}
                  >
                    Date{renderSortIcon("date")}
                  </th> */}
                </tr>
              </thead>
              <tbody>
                {data?.map((item, index) => {
                  const createdTime = new Date(
                    item?.created_at + "Z"
                  ).getTime();
                  const within5Min = Date.now() - createdTime <= 5 * 60 * 1000;
                  return (
                    <tr
                      key={item.id}
                      style={
                        item?.is_free_service
                          ? { backgroundColor: "rgba(220, 53, 69, 0.05)" }
                          : {}
                      }
                    >
                      <td>
                        <div className="d-flex align-items-start">
                          <div
                            className="d-flex flex-column"
                            onClick={() => {
                              handleToggleBillModal();
                              setSelectBill(item);
                            }}
                          >
                            <span className="text-primary fw-medium cursor-pointer">
                              {item?.invoice_id || "-"}
                            </span>
                            <small
                              className="text-darker"
                              style={{ fontSize: "0.82rem" }}
                            >
                              {item?.date
                                ? format(new Date(item?.date), "dd MMM yyy")
                                : "-"}
                            </small>
                          </div>

                          {within5Min && userRole=='user'&& (
                            <Link
                              to={`/bill-edit/${item?.id}`}
                              className="rounded-2 btn btn-outline-light btn-sm ms-1 mt-1 cursor-pointer text-primary"
                              style={{ padding: "0.3rem" }}
                              onClick={(e) => {
                                e.stopPropagation();
                              }}
                            >
                              <FiEdit2 size={10} />
                            </Link>
                          )}
                        </div>
                      </td>
                      <td>
                        <div className="d-flex flex-column">
                          {" "}
                          <div className="d-flex gap-1 align-items-center">
                            <span>{item?.vehicle?.vehicle_number || "-"}</span>
                            <CustomTooltip
                              title={
                                <div>
                                  <div>
                                    <strong>Vehicle Type:</strong>{" "}
                                    {item?.vehicle?.vehicle_type || "-"}
                                  </div>
                                  <div>
                                    <strong>Model:</strong>{" "}
                                    {item?.vehicle?.vehicle_model?.name || "-"}
                                  </div>
                                  <div>
                                    <strong>Customer Name:</strong>{" "}
                                    {item?.vehicle?.customer_name || "-"}
                                  </div>
                                  <div>
                                    <strong>Customer Contact:</strong>{" "}
                                    {item?.vehicle?.customer_contact || "-"}
                                  </div>
                                  <div>
                                    <strong>Total Services:</strong>{" "}
                                    {item?.vehicle?.total_services_completed ??
                                      "-"}
                                  </div>
                                </div>
                              }
                              placement="right"
                            >
                              <span
                                className="rounded-1 ms-1 btn btn-sm btn-outline-light"
                                style={{
                                  cursor: "pointer",
                                  padding: "0.2rem 0.2rem",
                                }}
                              >
                                <FaInfo size={9} className="text-dark" />
                              </span>
                            </CustomTooltip>
                          </div>
                          <small
                            className="text-darker"
                            style={{ fontSize: "0.82rem" }}
                          >
                            {item?.vehicle?.vehicle_model?.name || "-"}(
                            {item?.vehicle?.vehicle_type || "-"})
                          </small>
                        </div>
                      </td>
                      <td>
                        <div className="d-flex flex-column">
                          <span>{item?.vehicle?.customer_name || "-"}</span>
                          <small
                            className="text-darker"
                            style={{ fontSize: "0.82rem" }}
                          >
                            ({item?.vehicle?.customer_contact || "-"})
                          </small>
                        </div>
                      </td>
                      <td>
                        {item?.subtotal
                          ? `₹${formatToIndianNumber(item?.subtotal)}`
                          : "0"}
                      </td>
                      <td>
                        <div className="d-flex gap-1 align-items-center">
                          <span>
                            {" "}
                            {item?.discount
                              ? `₹${formatToIndianNumber(item?.discount)}`
                              : "0"}
                          </span>
                          {item?.discount && Number(item?.discount) > 0 && (
                            <CustomTooltip
                              title={item?.remark || ""}
                              placement="right"
                            >
                              <span
                                className="rounded-1 ms-1 btn btn-sm btn-outline-light"
                                style={{
                                  cursor: "pointer",
                                  padding: "0.2rem 0.2rem",
                                }}
                              >
                                <FaInfo size={9} className="text-dark" />
                              </span>
                            </CustomTooltip>
                          )}
                        </div>
                      </td>
                      <td>
                        {item?.tips
                          ? `₹${formatToIndianNumber(item?.tips)}`
                          : "0"}
                      </td>
                      <td>
                        {item?.payment_status == "PARTIALLY_PAID"
                          ? `₹${formatToIndianNumber(
                              item?.partial_amount || 0
                            )}`
                          : item?.payment_status == "PAID"
                          ? `₹${formatToIndianNumber(item?.total || 0)}`
                          : 0}
                      </td>
                      <td>
                        {item?.is_free_service ? (
                          <span className="badge text-bg-info-soft rounded-pill">
                            Free
                          </span>
                        ) : item?.payment_status === "PAID" ? (
                          <span className="rounded-pill badge text-bg-success-soft d-inline-flex align-items-center gap-1 px-2 py-1">
                            <FaCheckCircle size={13} /> Paid
                          </span>
                        ) : item?.payment_status === "UNPAID" ||
                          item?.payment_status === "PARTIALLY_PAID" ? (
                          <span
                            onClick={
                              userRole === "user"
                                ? () => {
                                    setSelectBill(item);
                                    handleTogglePaymentModal();
                                  }
                                : undefined
                            }
                            className={`rounded-pill badge d-inline-flex align-items-center gap-1 px-2 py-1 ${
                              item?.payment_status === "UNPAID"
                                ? "text-bg-danger-soft"
                                : "text-bg-warning-soft"
                            } ${userRole === "user" ? "cursor-pointer" : ""}`}
                          >
                            {item?.payment_status === "UNPAID" ? (
                              <>
                                <FaTimesCircle size={13} /> Unpaid{" "}
                                {userRole === "user" && <FaEdit size={12} />}
                              </>
                            ) : (
                              <>
                                <FaAdjust size={13} /> Partially Paid{" "}
                                {userRole === "user" && <FaEdit size={12} />}
                              </>
                            )}
                          </span>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td>
                        {item?.payment_method
                          ? paymentMethodBadge(item?.payment_method)
                          : "-"}
                      </td>
                      {/* <td>
                      {item?.date
                        ? format(new Date(item?.date), "dd MMM yyy")
                        : "-"}
                    </td> */}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center my-4">No data found</div>
        )}
        {!loading && data?.length > 0 && (
          <div className="p-4">
            <Pagination
              currentPage={param.page}
              recordsPage={param.page_size}
              dataLength={total}
              handlePagination={handlePageChange}
            />
          </div>
        )}
      </div>

      <Dialog
        open={billDetailsModal}
        onClose={handleToggleBillModal}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 2, overflow: "hidden" },
        }}
      >
        <DialogTitle
          className="d-flex justify-content-between align-items-center border-bottom mb-3"
          sx={{ p: 2, pb: 1 }}
        >
          <span className="fw-medium" style={{ fontSize: "1.1rem" }}>
            {selectBill?.service_center || "-"}
          </span>

          <IconButton onClick={handleToggleBillModal} size="small">
            <IoClose size={20} />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{ p: 3, maxHeight: "80vh", overflowY: "auto" }}
          className="scroll-container"
        >
          <div className="d-flex justify-content-between flex-wrap mb-2 gap-2">
            <div className="text-start">
              <h6 className="fw-bold">Vehicle Details</h6>
              <p className="mb-0">
                <span
                  className="fw-medium text-darker"
                  style={{ fontSize: "0.9rem" }}
                >
                  {selectBill?.vehicle?.vehicle_number}
                </span>{" "}
                <span
                  className="fw-medium text-dark me-1"
                  style={{ fontSize: "0.85rem" }}
                >
                  ({selectBill?.vehicle?.vehicle_type})
                </span>
              </p>
              <p
                className="fw-medium text-darker mb-0"
                style={{ fontSize: "0.8rem" }}
              >
                {selectBill?.vehicle?.vehicle_model?.brand?.name}
                {">"}
                {selectBill?.vehicle?.vehicle_model?.name}
              </p>
              <p className="mb-0">
                <span
                  className="fw-medium text-dark me-1"
                  style={{ fontSize: "0.85rem" }}
                >
                  Customer Name
                </span>
                <span
                  className="fw-medium text-darker"
                  style={{ fontSize: "0.9rem" }}
                >
                  {selectBill?.vehicle?.customer_name || "-"}
                </span>
              </p>
              <p className="mb-0">
                <span
                  className="fw-medium text-dark me-1"
                  style={{ fontSize: "0.85rem" }}
                >
                  WhatsApp Number
                </span>
                <span
                  className="fw-medium text-darker"
                  style={{ fontSize: "0.9rem" }}
                >
                  {selectBill?.vehicle?.customer_contact || "-"}
                </span>
              </p>
            </div>

            <div className="text-start text-sm-end">
              <h5 className="fw-bold mb-1">Invoice Info:</h5>
              <p className="mb-0">
                <span
                  className="fw-medium text-dark me-1"
                  style={{ fontSize: "0.85rem" }}
                >
                  Invoice #:{" "}
                </span>
                <span
                  className="fw-medium text-darker"
                  style={{ fontSize: "0.9rem" }}
                >
                  {selectBill?.invoice_id}
                </span>
              </p>
              <p className="mb-0">
                <span
                  className="fw-medium text-dark me-1"
                  style={{ fontSize: "0.85rem" }}
                >
                  Date:
                </span>
                <span
                  className="fw-medium text-darker"
                  style={{ fontSize: "0.9rem" }}
                >
                  {selectBill?.date}
                </span>
              </p>

              {!selectBill?.is_free_service ? (
                <>
                  <p className="mb-0">
                    <span
                      className="fw-medium text-dark me-1"
                      style={{ fontSize: "0.85rem" }}
                    >
                      Payment Status:
                    </span>
                    {selectBill?.payment_status
                      ? paymentStatusBadge(selectBill?.payment_status)
                      : "-"}
                  </p>
                  {selectBill?.payment_status === "PARTIALLY_PAID" && (
                    <p className="mb-0">
                      <span
                        className="fw-medium text-dark me-1"
                        style={{ fontSize: "0.85rem" }}
                      >
                        Partial Amount:
                      </span>
                      <span
                        className="fw-medium text-darker"
                        style={{ fontSize: "0.9rem" }}
                      >
                        ₹{selectBill?.partial_amount}
                      </span>
                    </p>
                  )}
                </>
              ) : (
                <span className="badge text-bg-info-soft">Free Service</span>
              )}
            </div>
          </div>

          <div className="table-responsive">
            <table className="table table-sm fs-6 table-borderedless align-middle">
              <thead className="bg-light">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Service Name</th>
                  <th scope="col">Vehicle Type</th>
                  <th scope="col" className="text-end">
                    Price (₹)
                  </th>
                </tr>
              </thead>
              <tbody>
                {selectBill?.service_details?.map((service, index) => (
                  <tr key={service?.id}>
                    <td>{index + 1}</td>
                    <td>{service?.name}</td>
                    <td>{service?.vehicle_type}</td>
                    <td className="text-end">{service?.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {!selectBill?.is_free_service && (
            <div
              className="d-flex justify-content-end"
              style={{ fontSize: "0.85rem" }}
            >
              <div className="w-100" style={{ maxWidth: "300px" }}>
                <div className="d-flex justify-content-between py-1">
                  <strong>Subtotal</strong>
                  <span>₹{selectBill?.subtotal}</span>
                </div>
                <div className="d-flex justify-content-between py-1 text-danger">
                  <strong>Discount</strong>
                  <span>₹{selectBill?.discount}</span>
                </div>
                <div className="d-flex justify-content-between py-1 text-darker">
                  <strong>Tips</strong>
                  <span>₹{selectBill?.tips || 0}</span>
                </div>
                <hr className="my-2" />
                <div className="d-flex justify-content-between py-1">
                  <strong className="fs-5">Total</strong>
                  <strong className="fs-5">₹{selectBill?.total}</strong>
                </div>
                {selectBill?.payment_method && (
                  <div className="d-flex justify-content-between py-1">
                    <strong>Payment Method</strong>
                    <span>{selectBill?.payment_method}</span>
                  </div>
                )}
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      <BillingEditPaymnetModal
        data={selectBill || null}
        visible={editPaymentModal}
        onClose={handleTogglePaymentModal}
        onAfterSubmit={handleAfterEditPayment}
      />
    </div>
  );
};

export default Billing;
